/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import BorderLoader from "components/atoms/loader/BorderLoader";
import { useI18n } from "hooks/i18n/i18n";
import React from "react";

import type { FC } from "react";

export const StreamingLiveCommerceAmountV2: React.FC<{
  isDarkModeEnabled: boolean;
  cartTotalFee: number;
  shippingFee: number;
  settlementFee: number;
  totalFee: number;
  isCalculatingShippingFee: boolean;
}> = ({
  isDarkModeEnabled,
  cartTotalFee,
  shippingFee,
  settlementFee,
  totalFee,
  isCalculatingShippingFee,
}) => {
  const FONT_WEIGHT = 700;

  const { t } = useI18n();

  return (
    <div>
      <div
        css={css`
          display: flex;
          gap: 12px;
          flex-direction: column;
          padding-bottom: 24px;
          margin-bottom: 24px;
          border-bottom: 1px solid #e0e0e0;
        `}
      >
        <LiveCommerceAmountItemLayout isDarkModeEnabled={isDarkModeEnabled}>
          <p>{t("streaming.commerceCart.productTotal")}</p>
          <p
            css={css`
              font-weight: ${FONT_WEIGHT};
            `}
          >
            ¥{cartTotalFee.toLocaleString()}
          </p>
        </LiveCommerceAmountItemLayout>

        <LiveCommerceAmountItemLayout isDarkModeEnabled={isDarkModeEnabled}>
          <p>{t("streaming.commerceCart.shippingFee")}</p>
          {isCalculatingShippingFee ? (
            <BorderLoader height="20px" width="40px" />
          ) : (
            <p
              css={css`
                font-weight: ${FONT_WEIGHT};
              `}
            >
              ¥{shippingFee.toLocaleString()}
            </p>
          )}
        </LiveCommerceAmountItemLayout>

        <LiveCommerceAmountItemLayout isDarkModeEnabled={isDarkModeEnabled}>
          <p>{t("streaming.commerceCart.settlementFee")}</p>
          <p
            css={css`
              font-weight: ${FONT_WEIGHT};
            `}
          >
            ¥{settlementFee.toLocaleString()}
          </p>
        </LiveCommerceAmountItemLayout>
      </div>

      <LiveCommerceAmountItemLayout isDarkModeEnabled={isDarkModeEnabled}>
        <p
          css={css`
            font-size: 16px;
            font-weight: ${FONT_WEIGHT};
          `}
        >
          {t("streaming.commerceCart.total")}
          <span
            css={css`
              font-size: 12px;
            `}
          >
            {t("streaming.commerceCart.taxIncluded")}
          </span>
        </p>
        <p
          css={css`
            font-weight: ${FONT_WEIGHT};
          `}
        >
          ¥{totalFee.toLocaleString()}
        </p>
      </LiveCommerceAmountItemLayout>
    </div>
  );
};

const LiveCommerceAmountItemLayout: FC<{
  isDarkModeEnabled: boolean;
  children: [React.ReactNode, React.ReactNode];
}> = ({ isDarkModeEnabled, children }) => {
  return (
    <div
      css={css`
        display: flex;
        justify-content: space-between;
        color: ${isDarkModeEnabled ? "#fff" : "#000"};
        font-size: 14px;
      `}
    >
      {children}
    </div>
  );
};
